import { KeysysToastProps } from "./KeysysToastProps";

export const ErrorToast = (message?: string, msDelay?: number): KeysysToastProps => ({
    name: message ?? "ERROR",
    theme: "danger",
    titleInHeader: "Error",
    body: message ?? "There was a problem processing that request.",
    delay: msDelay ?? 12000,
});